import React from 'react'
import { NavLink } from 'react-router-dom'

export default function Navbar() {
  return (
    <div className='navbr'>
        <nav className="navbar navbar-expand-lg ">
  <div className="container-fluid ">
    <span >Mussafara Riaz</span>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon .text-primary"></span>
    </button>
    <div className="collapse navbar-collapse text-primary" id="navbarNavDropdown">
      <ul className="navbar-nav ">
        <li className="nav-item ">
          <NavLink to='/' className='nav-link  text-light'>Home</NavLink>
          </li>
        
        <li className="nav-item">
        <NavLink to='/skills' className='nav-link active text-light' >About</NavLink>
        </li>
        <li className="nav-item">
        <NavLink to='/card' className='nav-link active text-light' >Projects</NavLink>
        </li>
        <li className="nav-item">
 <NavLink to='/certification' className='nav-link active text-light' >Certification</NavLink>
    
        </li>
    
        
      </ul>
      <span ><a href="https://github.com/MUSSAFARA-RIAZ"><i class="fa-solid fa-code-branch"></i></a></span>
    </div>
  </div>
  
  
  
</nav>


      
    </div>
  )
}